import { Modal, Box, IconButton, Typography, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { FareRule, Itinerary } from '~/types';
import FareRulesAccordion from './FareRulesAccordion';
import { useTheme } from '@mui/material/styles';

interface FairRulesModalProps {
  fareRules: Record<string, FareRule>;
  itinerary: Itinerary;
  onClose: () => void;
  open: boolean;
}

const FairRulesModal = ({ fareRules, itinerary, open, onClose }: FairRulesModalProps) => {
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Modal
      open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: 5,
        maxHeight: "90%",
        overflowY: 'auto',
        minWidth: isMdDown ? '80%' : '65%',
        maxWidth: isMdDown ? '80%' : 'auto',
      }}>
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', top: 10, right: 10 }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
          Fare Rules
        </Typography>
        <FareRulesAccordion
          itinerary={itinerary}
          fareRules={fareRules}
        />
      </Box>
    </Modal>
  );
};

export default FairRulesModal;
